/**
 * Where the focus goes when a control in Sealed's list leaves the page with it: its own row, still drawn once read
 * archived; else the row now standing where it stood, the next one drawn or else the one before it (an archived row
 * gone from "In stock", or from a search); else the first row (the empty list's Add, gone with the first box). A row
 * goes by `drawn`, the products as the list showed them before. The row's first button takes the focus, or the row
 * itself when it has none.
 */
export function rowStandIn(left: Element, rows: readonly HTMLElement[], drawn: readonly string[]): HTMLElement | null {
  const product = left.getAttribute("data-product");
  const byId = new Map(rows.map((row) => [row.dataset.product, row]));
  const own = product === null ? undefined : byId.get(product);
  const at = product === null ? -1 : drawn.indexOf(product);
  const near = at < 0 ? [] : [...drawn.slice(at + 1), ...drawn.slice(0, at).reverse()];
  const row = own ?? near.map((id) => byId.get(id)).find((r) => r !== undefined) ?? rows[0];
  if (row === undefined) return null;
  const button = row.querySelector<HTMLElement>("button");
  if (button !== null) return button;
  if (!row.hasAttribute("tabindex")) row.setAttribute("tabindex", "-1");
  return row;
}
